module.exports = __webpack_public_path__ + "assets/d307eea7d1d63ae0669caf8c909cf0ee.mp4";